import upperFirst from 'lodash/fp/upperFirst';
import styles from './Padding.module.scss';
import { SupportedSize } from './Element';

export type PaddingProps = {
  size?: SupportedSize;
  vertical?: SupportedSize;
  horizontal?: SupportedSize;
  left?: SupportedSize;
  right?: SupportedSize;
  top?: SupportedSize;
  bottom?: SupportedSize;
};
// Alias for backwards compatibility
export type SpacingShape = PaddingProps;

export default ({
  size,
  vertical = size,
  horizontal = size,
  left = horizontal,
  right = horizontal,
  top = vertical,
  bottom = vertical,
}: PaddingProps) => {
  const classes: string[] = [];

  if (left) classes.push(styles[`padding__size${upperFirst(left)}Left`]);
  if (right) classes.push(styles[`padding__size${upperFirst(right)}Right`]);
  if (top) classes.push(styles[`padding__size${upperFirst(top)}Top`]);
  if (bottom) classes.push(styles[`padding__size${upperFirst(bottom)}Bottom`]);

  return classes;
};
